import React from "react";

const UploadFourB = () => {
	return (
		<div className='upload-container'>
			<h1>
				Zaradi tehničnih težav je zaenkrat možno oddajanje datotek le z uporabo
				google računa.
			</h1>
			<h2>1. Vpiši ime in klikni "Add file"</h2>
			<h2>2. Klikni "Select files from your device" in izberi datoteko</h2>
			<h2>
				3. Klikni "Upload" levo spodaj ter počakaj, da se datoteka naloži.
			</h2>
			<h2>4. Klikni "SUBMIT</h2>
			<iframe src='https://docs.google.com/forms/d/e/1FAIpQLSf_knK-B3AXkc20CkHwc21hIVGOpwRbgo2jIGZeK5tBJDUbOg/viewform?usp=sf_link'></iframe>
		</div>
	);
};

export default UploadFourB;
